const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                    ['icon', [this, 'block_icon']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                context.proxy[`tag_name`] = (((context.has(`tag_name`))) ? (this.env.getFilter('default').traceableCallable(1, this.source)(...[(context.has(`tag_name`) ? context.get(`tag_name`) : null), `div`])) : (`div`));
                this.echo(`
`);
                this.startOutputBuffer();
                this.echo(`  `);
                this.traceableDisplayBlock(4, this.source)('icon', context.clone(), blocks);
                context.proxy[`_icon_block`] = (() => {let tmp = this.getAndCleanOutputBuffer(); return tmp === '' ? '' : new this.Markup(tmp, this.env.getCharset());})();
                this.echo(`
<`);
                this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(` class="c-alert`);
                if ((context.has(`floating`) ? context.get(`floating`) : null)) {
                    this.echo(` c-alert--floating`);
                }
                if ((context.has(`class`) ? context.get(`class`) : null)) {
                    this.echo(` `);
                    this.echo(this.env.getFilter('escape').traceableCallable(13, this.source)(...[this.env, (context.has(`class`) ? context.get(`class`) : null), `html`, null, true]));
                }
                this.echo(`">
  <div class="c-alert__inner">
    `);
                if ( !this.env.getTest('empty').traceableCallable(15, this.source)(...[this.env.getFilter('trim').traceableCallable(15, this.source)(...[(context.has(`_icon_block`) ? context.get(`_icon_block`) : null)])])) {
                    this.echo(`      <span class="c-alert__extra">
        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(17, this.source)(...[this.env, (context.has(`_icon_block`) ? context.get(`_icon_block`) : null), `html`, null, true]));
                    this.echo(`
      </span>
    `);
                }
                this.echo(`    <div class="c-alert__content">
      `);
                this.traceableDisplayBlock(21, this.source)('content', context.clone(), blocks);
                this.echo(`    </div>
    `);
                if ((context.has(`dismissable`) ? context.get(`dismissable`) : null)) {
                    this.echo(`      <button class="c-alert__dismiss" type="button">
        `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`class`, `c-alert__dismiss-icon`], [`name`, `x`]]), true, false, 29));
                    this.echo(`        <span class="u-hidden-visually">Dismiss alert</span>
      </button>
    `);
                }
                this.echo(`  </div>
</`);
                this.echo(this.env.getFilter('escape').traceableCallable(37, this.source)(...[this.env, (context.has(`tag_name`) ? context.get(`tag_name`) : null), `html`, null, true]));
                this.echo(`>
`);
            }

            block_icon(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                if ((context.has(`icon`) ? context.get(`icon`) : null)) {
                    this.echo(`      `);
                    this.echo(this.include(context, this.source, `@cloudfour/components/icon/icon.twig`, new Map([[`name`, (context.has(`icon`) ? context.get(`icon`) : null)]]), false, false, 6));
                    this.echo(`    `);
                }
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <p>
          `);
                this.echo(this.env.getFilter('escape').traceableCallable(23, this.source)(...[this.env, (((context.has(`message`))) ? (this.env.getFilter('default').traceableCallable(23, this.source)(...[(context.has(`message`) ? context.get(`message`) : null), `Hello world!`])) : (`Hello world!`)), `html`, null, true]));
                this.echo(`
        </p>
      `);
            }

            getTemplateName() {
                return `d168ec1f60953e7289e9b916cf22b174e37b64c3673e9854dd9d92522c6e23a0`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `d168ec1f60953e7289e9b916cf22b174e37b64c3673e9854dd9d92522c6e23a0`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'd168ec1f60953e7289e9b916cf22b174e37b64c3673e9854dd9d92522c6e23a0');

let template = env.loadTemplate('d168ec1f60953e7289e9b916cf22b174e37b64c3673e9854dd9d92522c6e23a0');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/components/alert/alert.twig", args: context }
     );
     return rendered;;
};